// extracted by mini-css-extract-plugin
export default {"box_border":"CustomModalOverlay_box_border__mNv5E","fixedScrollbar":"CustomModalOverlay_fixedScrollbar__AG0RP"};